const allowedModules = [
    'Client'
];
if (!allowedModules.includes(global.MODULE)) throw new Error(`Only allowed in ${allowedModules.join(', ')}`);
export * from './AudioManager.ts';
export * from './AudioType.ts';
